export const getTicketAliasFromPathname = (pathname) => {
  const regex = /(^[:])/;
  const splitPathname = pathname.split('/');
  const findTicketAlias = splitPathname.find((path) => path.includes(':'));
  const ticketAlias = findTicketAlias
    ? findTicketAlias.replace(/[:]/, '')
    : null;
  return ticketAlias;
};
